import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
import { ROUTE_BROWSE_JOBS_NEW, ROUTE_COMPLETE_PROFILE } from "../../constants/routes";

const JobsCongrats = () => {
  const navigate = useNavigate();

  return (
    <section className="opportunities-bg" style={{ height: "100vh" }}>
      <img
        src="/images/opportunities.png"
        alt=""
        className="img-fluid"
        style={{ position: "absolute", bottom: "0", left: "10%", width: "300px" }}
      />
      <Container maxWidth="md" sx={{ position: "relative", zIndex: "99" }}>
        <div className="text-center pt-4 mb-0">
          <h6 className="text-white pt-5" style={{ fontSize: "27px" }}>
            Congratulations! <br /> Application received.
          </h6>
          <p className="text-white mt-2">
          If shortlisted, the company will reach out for an interview
          </p>
        </div>

        <h6 className="text-white pt-5 text-center" style={{ fontSize: "27px" }}>
          What&apos;s next?
        </h6>

        <div className="mx-lg-5 mt-3">
          <Button
            onClick={() => navigate(ROUTE_BROWSE_JOBS_NEW)}
            sx={{
              fontWeight: 600,
              backgroundColor: "#6352cc",
              textTransform: "capitalize",
              fontSize: "16px",
              padding: "15px 0px",
              borderRadius: "99px",
              "&:hover": {
                backgroundColor: "#6352cc",
              },
            }}
            className="w-100 text-white mt-3"
            variant="text"
          >
            Browse More Jobs
          </Button>

          <Button
            onClick={() => navigate(ROUTE_COMPLETE_PROFILE)}
            sx={{
              fontWeight: 600,
              backgroundColor: "#fff",
              color: "#6352CC",
              textTransform: "capitalize",
              fontSize: "16px",
              padding: "15px 0px",
              borderRadius: "99px",
              "&:hover": {
                backgroundColor: "#fff",
              },
            }}
            className="w-100  mt-3"
            variant="text"
          >
            Back to Profile
          </Button>
        </div>
      </Container>
    </section>
  );
};

export default JobsCongrats;
